// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Links_wrap__tuuwg","link":"Links_link__Ol6Dl","mobile":"Links_mobile__UksfT"};